import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getIndividualUsers } from "../../../actions/admin/user";
import { ON_GET_INDIVIDUAL_USER } from "../../../actions/types";
import AdminPage from "../_components/AdminPage";
import AdminTable from "../_components/AdminTable";
import IndividualUserItem from "./IndividualUseritem";
import Filter from "./_components/Filter";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Name", width: "tw:w-[260px]", sortField: "name" },
  { key: "email", title: "Email", width: "tw:w-[300px]", sortField: "email" },
  { key: "status", title: "Status", width: "tw:w-[220px]", sortField: "status", skeleton: "badge" },
  { key: "lastBooked", title: "Last Booked", width: "tw:w-[180px]" },
  { key: "createdOn", title: "Created Date", width: "tw:w-[180px]", sortField: "date" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const IndividualUserList = () => {
  const individualuser = useSelector((state) => state.individualuser);
  const { loading, individualUsers } = individualuser;
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState({
    sortBy: "asc",
    orderBy: "date",
    page: 1,
    limit: 100,
    disableCalculateTotal: false,
    draw: 1,
    id: "",
    role: "individual",
    status: "",
  });

  // debounce effect
  useEffect(() => {
    dispatch({
      type: ON_GET_INDIVIDUAL_USER,
    });
    const handler = setTimeout(() => {
      dispatch(getIndividualUsers({ ...query, search }));
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, query, search]);

  const requestSort = (key) => {
    setQuery((prev) => ({
      ...prev,
      orderBy: key,
      sortBy: prev.orderBy === key && prev.sortBy === "asc" ? "desc" : "asc",
    }));
  };

  const rows = individualUsers?.data || [];

  return (
    <AdminPage title="Individual User List">
      <Filter
        search={search}
        setSearch={setSearch}
        onApplyStatus={(status) => setQuery((prev) => ({ ...prev, status }))}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1320}
        sortConfig={{ key: query.orderBy, direction: query.sortBy }}
        onSort={requestSort}
        loading={loading}
        skeletonRowCount={10}
        isEmpty={!rows.length}
        emptyText="No users found."
      >
        {rows.map((item, index) => (
          <IndividualUserItem key={item._id} user={item} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default IndividualUserList;
